import {  } from '@reduxjs/toolkit';
import { Api } from '../../Api/Api';
import { AppDispatch, RootState } from '../Store';
import { IUpdateTargetYield } from '../../Models/Requests/SourceUpdateTypes';
import { createTracedAsyncThunk } from '../../../tracing/trace';

export interface IUpdateTargetYieldRequest extends IUpdateTargetYield
{
	FieldId: string;
	FieldYear: string;
}

export const updateTargetYieldForField = createTracedAsyncThunk<object, IUpdateTargetYieldRequest, { dispatch: AppDispatch, state: RootState }>(
	'update/targetyieldforfield',
	async (context, request: IUpdateTargetYieldRequest, thunkAPI) => 
	{
		try
		{
			const api = new Api('/api/6', thunkAPI.getState().auth.userAuthToken, context);
			const { FieldId, FieldYear } = request;
			
			const response = await api.postAsync<object>(`fields/${FieldId}/years/${FieldYear}/targetYield`, request);

			if (response.ErrorCode === null && response.Success) 
			{
				// 10/18/2022 - this function actually returns a FieldYearProjection but we do not currently care about the return data, only that it was a success
				return true;
			}
			else 
			{
				return thunkAPI.rejectWithValue(response.ErrorMessage);
			}
		}
		// Likely a NetError thrown from the Api class
		catch (e)
		{
			return thunkAPI.rejectWithValue(e.message);
		}
	}
);